/** Passer à `true` pour réactiver SocialNetworksLegacy pour tous. */
export const SOCIAL_NETWORKS_USE_LEGACY = false

export function isSocialNetworksRefonteEnabled () {
  return !SOCIAL_NETWORKS_USE_LEGACY
}
